export default "__VITE_ASSET__71583541__"